jQuery(window).load(function () {
    setTimeout(function () {
        $('#preloader').addClass('hide');
    },500);
});
(function($) {

    $(window).on('load resize', function () {

        /**
         *  set adaptive viewport on screens smaller then 640 and bigger than 1200
         *  set static viewport on screens between 641px and 1199
         */

        var mediaCheckMobile = window.matchMedia('(max-width: 640px)');
        var mediaCheckTablet = window.matchMedia('(min-width: 980px) and (max-width: 1199px)');
        var mediaCheckDesktop = window.matchMedia('(min-width: 1200px)');
        var viewport = document.getElementById('viewport');

        if (mediaCheckMobile.matches) {
            viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
        } else if (mediaCheckTablet.matches) {
            viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
        } else if (mediaCheckDesktop.matches) {
            viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
        }
    });
})(jQuery);
$(document).ready(function () {

    $("img, a, button").on("dragstart", function(event) { event.preventDefault(); });
    

    $('.js-map-toggle').on('click', function (e) {
        e.preventDefault();

        $(this).toggleClass('open');

        $('.js-map').slideToggle();
    });

   
    //Anchor link
    $('.js-anchor-link').on('click', function(e) {
        e.preventDefault();

        var id = $(this).attr('href');

        var targetOffset = +$(id).offset().top - +$('.fixed_header_item').height();

        $('body, html').animate({scrollTop: targetOffset}, 1000);

    });

    //More link
    $('.js-more-link').on('click', function(e) {
        e.preventDefault();
        
        var $items = $(this).closest('.js-more').find('.js-more-item');

       $(this).hide();
        $items.slideDown();
    });

    $('.js-more-rotate-link').on('click', function(e) {
        e.preventDefault();

        var $items = $(this).closest('.js-more-rotate').find('.js-more-rotate-item');

        $(this).toggleClass('open');
        $items.slideToggle();
    });
    
    //Tags more
    $('.js-tags-more').on('click', function(e) {
        e.preventDefault();

        $(this).closest('.js-tags').addClass('open');

        $(this).hide();
    });
    
    //Faq
    $('.js-faq-toggle').not('.faq__item_disabled .js-faq-toggle').on('click',function (e) {
        e.preventDefault();
       var parent = $(this).closest('.js-faq');
        
        parent.toggleClass('open');
        parent.find('.js-faq-item').slideToggle();
    });
    
});
// (function($) {
//
//     function linkHighlight(linkClass) {
//
//         /* highlight active menu item*/
//         $(linkClass).each(function (index) {
//             if (this.href.trim() == window.location)
//                 $(this).addClass('link_active');
//         });
//     }
//
//     linkHighlight('.nav__link');
//
// })(jQuery);
(function($) {

    function smoothScroll(link) {

        $(link).click(function () {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top - 160
                    }, 600);
                    return false;
                }
            }
        });
    }

    smoothScroll( '.sol_link, .js-smooth-scroll' );

})(jQuery);
$(document).ready(function() {
    var scrollList = $('.js-scroll-container');
    
    var mouseWheelOption = true;
    
    if ($(window).width() < 981) {
        mouseWheelOption = false
    }

    scrollList.mCustomScrollbar({
        theme: "default",
        axis:"x",
        scrollButtons: false,
        autoDraggerLength: false,
        scrollInertia: 200,
        keyboard: {
            enable: true,
            scrollType: "stepless"
        },
        documentTouchScroll: false,
        contentTouchScroll:30,
        mouseWheel:{ enable: mouseWheelOption }
    });
    
    
    var mapScroll = $('.map_svg_block .map_image');

    if ($(window).width() < 981) {
        var setLeft = (1200 - +$(window).width())/2;

        mapScroll.mCustomScrollbar({
            theme: "default",
            axis:"x",
            scrollButtons: false,
            autoDraggerLength: false,
            scrollInertia: 200,
            documentTouchScroll: false,
            contentTouchScroll:30,
            setLeft: "-"+setLeft+"px",
            mouseWheel: false
        });
    }
});
$(document).ready(function () {
    //Dropdown
    var $formDropdown = $('.js-dropdown'),
        $formDropdownItem = $('.js-dropdown .js-dropdown-item');

    $formDropdown.on('click',function (e) {
        e.preventDefault();

        var isList = $(e.target).hasClass('js-dropdown-item') || $(e.target).closest('ul').hasClass('js-dropdown-list') || $(e.target).hasClass('js-dropdown-list');
        
        if (!isList) {
            if ($(this).hasClass('open')) {
                $(this).removeClass('focused open');
                $(this).find('input').blur();
            } else {
                $(this).find('input').focus();
                $(this).addClass('focused open');
            }
        }
    });

    jQuery(document).click(function (e) {
        var isDropdown = $(e.target).hasClass('js-dropdown') || $(e.target).closest('div').hasClass('js-dropdown');
        
        if (!isDropdown) {
            $('.js-dropdown').removeClass('focused open');
        }
    });

    $formDropdownItem.on('click', function (e) {
        e.preventDefault();

        var value = $(this).data('value');
        var parentDropdown = $(this).closest('.js-dropdown');
        
        parentDropdown.find('input').attr('value',value).val(value).addClass('filled');
        
        parentDropdown.removeClass('open focused error');
    });
    	
	$('.dropdown').each(function () {
	
	    // Cache the number of options
	    var $dropdown = $(this),
	        $dropdowns = $('.dropdown').not(this),
	        $dropdownText = $dropdown.find('.dropdown__text'),
	        $dropdownList = $dropdown.find('.dropdown__list'),
	        $dropdownListItems = $dropdown.find('.dropdown__item');
	
	    // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
	    $dropdown.on('click', function(e) {
	        e.stopPropagation();
	        $dropdowns.removeClass('dropdown_opened');
	        $dropdowns.find('.dropdown__list').slideUp(250);
	
	        if ($dropdown.hasClass('dropdown_opened')) {
	            $dropdown.removeClass('dropdown_opened');
	            $dropdown.find('.dropdown__list').slideUp(250);
	        } else {
	            $dropdown.addClass('dropdown_opened');
	            $dropdown.find('.dropdown__list').slideDown(250);
	        }
	    });
	
	    // Hides the unordered list when clicking outside of it
	    $(document.body).click( function() {
	        $dropdown.removeClass('dropdown_opened');
	        $dropdownList.slideUp(150);
	    });
	});
});
var inputValidate = function () { };
var formLocation = window.formLocation;
var formLocationCity = window.formLocationCity;
var countryError = false;
var cityError = false;


var validateCode = function (code){
    return /^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/i.test(code);
}

$(document).ready(function () {
    var scrollbarWidth = (function getScrollbarWidth() {
        var outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.width = "100px";
        outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

        document.body.appendChild(outer);

        var widthNoScroll = outer.offsetWidth;
        // force scrollbars
        outer.style.overflow = "scroll";

        // add innerdiv
        var inner = document.createElement("div");
        inner.style.width = "100%";
        outer.appendChild(inner);

        var widthWithScroll = inner.offsetWidth;

        // remove divs
        outer.parentNode.removeChild(outer);

        return widthNoScroll - widthWithScroll;
    })();

	$('.js-code-mask').mask('AAAA-AAAA-AAAA-AAAA');
	$('.js-phone-mask').mask('+0 000 0000000999');

    $('form').on("change keyup input", 'input, textarea', function () {
        if ($(this).val() !== '') {
            $(this).closest('.form_input_box').removeClass('error');
        }
    });

    $('form input[type="checkbox"]').on("change keyup input", function () {
        if ($(this).is(':checked')) {
            $(this).closest('.error').removeClass('error');
        }
    });

    $('[class^="js-quest-form"] input:not([type="checkbox"]):not([type="hidden"]):not([type="radio"]):not([name="_token"]):not([name="_method"]), .js-entry-form input:not([type="checkbox"]):not([type="hidden"]):not([type="radio"]):not([name="_token"]):not([name="_method"]), .confirm input:not([type="checkbox"]):not([type="hidden"]):not([type="radio"]):not([name="_token"]):not([name="_method"])').each(function () {
        var val = $(this).val();
        if (val !== '') {
            $(this).addClass('filled');
        }
    });
    $('[class^="js-quest-form"] textarea').each(function () {
        var val = $(this).val();
        if (val !== '') {
            $(this).addClass('filled');
        }
    });
    
    $('.form_dropdown_hidden').each(function () {
       var inputValue = $(this).find('input').val().toString().trim();
       
        if (inputValue.length > 0) {
            $(this).removeClass('disabled form_dropdown_hidden');
        }
    });
    
    $('form').on('focus', '.js-box-clone input', function(){
	    var parent =  $(this).parents('.forms_box_set');
	    // Проверяем есть ли не заполненный блок (текстовые поля)
	    var parent_container = parent.parent();
	    
		var blank = 0;
	    $('.forms_box_set',parent_container).not(parent).each(function(){
		    var is_blank = true;
		    $('input',this).each(function(){
			    if($(this).val() != '') is_blank = false;
		    });
		    if(is_blank) blank++;
	    });
	    if(blank==0){
		    var add = parent.clone();
		    add.find('input').val('');
		    add.find('.focused').removeClass('focused');
		    add.find('.js-box-required').removeClass('js-box-required').addClass('js-box-check');
		    add.find('.error').removeClass('error');
		    add.find('.lost-focus').removeClass('lost-focus');
		    add.find('.form_input_box .form-label').each(function(){
			    $(this).text($(this).text().replace('*',''));
		    });
		    if($(add).data('label')){
			    var count_box = $('.forms_box_set',parent_container).length + 1;
			    add.children('.form-label').text($(add).data('label').replace(':num',count_box));
		    }
			$('.forms_box_set',parent_container).last().after(add);
		}
    });

    var validateEmail = function (email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    var validatePhone = function (phone) {
        var re = /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,20}(\s*)?$/;
        return re.test(phone);
    };

    //Input validate
    var valueCount = 0;
    
    inputValidate = function (input) {
        var value = input.val();
        var box = input.closest('.js-box-required, .js-box');
        var box_check = input.closest('.js-box-check');

        if (!value && box.hasClass('js-box-required') && !box.hasClass('js-box-mobile')) {
            box.find('.form-error').text(box.find('.form-error').data('error'));
            box.addClass('error');
        } else if(value) {
            if (box.hasClass('js-box-name')) {
                var valuesCount = value.trim().split(' ').filter(function (v) { return v !== '' });

                if (valuesCount.length > 1) {
                    box.removeClass('error');
                } else {
                    box.find('.form-error').text(box.find('.form-error').data('alternate'));
                    box.addClass('error');
                }
            } else if (box.hasClass('js-dropdown-country')) {
                valueCount = value.toString().trim();

                if (valueCount.length > 1) {
                    box.removeClass('error');
                } else {
                    box.find('.form-error').text(box.find('.form-error').data('alternate'));
                    box.addClass('error');
                }

            } else if (box.hasClass('js-dropdown-city')) {
                valueCount = value.toString().trim();

                if (valueCount.length > 1) {
                    box.removeClass('error');
                } else {
                    box.find('.form-error').text(box.find('.form-error').data('alternate'));
                    box.addClass('error');
                }
            } else if (box.hasClass('js-box-phone')) {
                if (!validatePhone(value)) {
                    box.find('.form-error').text(box.find('.form-error').data('alternate'));
                    box.addClass('error');
                } else {
                    box.removeClass('error');
                }
            } else if (box.hasClass('js-box-mobile')) {
                if (!validatePhone(value) && value !== '') {
                    box.addClass('error');
                } else {
                    box.removeClass('error');
                }
            } else if (box.hasClass('js-box-email')) {
                if (!validateEmail(value)) {
                    box.find('.form-error').text(box.find('.form-error').data('alternate'));
                    box.addClass('error');
                } else {
                    box.removeClass('error');
                }
            } else if (box.hasClass('js-box-code')) {
                if (!validateCode(value)) {
                    box.find('.form-error').text(box.find('.form-error').data('alternate'));
                    box.addClass('error');
                } else {
                    box.removeClass('error');
                }                 
            } else if (box.hasClass('js-box-text')) {
                valueCount = value.toString().trim();

                if (valueCount.length > 1) {
                    box.removeClass('error');
                } else {
                    box.find('.form-error').text(box.find('.form-error').data('alternate'));
                    box.addClass('error');
                }
            } else if (box.hasClass('js-box-numeric')) {
                valueCount = value.toString().trim();

                if ($.isNumeric(value)) {
                    box.removeClass('error');
                } else {
                    box.find('.form-error').text(box.find('.form-error').data('alternate'));
                    box.addClass('error');
                }
            } else {
                box.removeClass('error');
            }
        }else {
            box.removeClass('error');
        }
        
        if (value!==''){
		    if(box_check.hasClass('js-box-name')) {
	            var valuesCount = value.trim().split(' ').filter(function (v) { return v !== '' });
	
	            if (valuesCount.length > 1) {
	                box_check.removeClass('error');
	            } else {
	                box_check.find('.form-error').text(box_check.find('.form-error').data('alternate'));
	                box_check.addClass('error');
	            }
	        }else if (box_check.hasClass('js-box-numeric')) {
	            valueCount = value.toString().trim();
	
	            if ($.isNumeric(value)) {
	                box_check.removeClass('error');
	            } else {
	                box_check.find('.form-error').text(box_check.find('.form-error').data('alternate'));
	                box_check.addClass('error');
	            }
	        }
	    }
    };
    
    //Entry submit
    $('.js-entry-form').submit(function (e) {

        var key = $(this).find('input[name*="key"]');
        var keyBox = $(this).find('input[name*="key"]').closest('.form_input_box');
        
        var code = $(this).find('input[name*="code"]');
        var codeBox = $(this).find('input[name*="code"]').closest('.form_input_box');

        var error = 0;

        if(key.length > 0) {
            if (key.val() === '') {
                keyBox.addClass('error');
                ++error;
            } else {
                if (key.val().toString().trim().length > 1) {
                    keyBox.removeClass('error');
                } else {
                    keyBox.find('.form-error').text(keyBox.find('.form-error').data('alternate'));
                    keyBox.addClass('error');
                    ++error;
                }
            }
        }
        
        if(code.length > 0) {
            if (code.val() === '') {
                codeBox.addClass('error');
                ++error;
            } else {
                if (validateCode(code.val())) {
                    codeBox.removeClass('error');
                } else {
                    codeBox.find('.form-error').text(codeBox.find('.form-error').data('alternate'));
                    codeBox.addClass('error');
                    ++error;
                }
            }
        }

        if (error) {
            e.preventDefault();
        }
    });


    // Проверка формы личного профайла
    $('.js-quest-form').submit(function (e) {
	    
        var fio = $(this).find('input[name="fio"]'),
            first_name = $(this).find('input[name="first_name"]'),
            sur_name = $(this).find('input[name="sur_name"]'),
            middle_name = $(this).find('input[name="middle_name"]'),
        	sex = $(this).find('input[name="sex"]'),
        	age = $(this).find('input[name="age"]'),
            phone = $(this).find('input[name="phone"]'),
            email = $(this).find('input[name="email"]'),
            company = $(this).find('input[name="company"]'),
            position = $(this).find('input[name="position"]'),
            stag = $(this).find('input[name="stag"]'),
            address = $(this).find('input[name="address"]'),
            country = $(this).find('input[name="country"]'),
            city = $(this).find('input[name="city"]'),
            agree = $(this).find('input[name="agree"]');

        var adressBox = $(this).find('input[name="address"]').closest('.form_input_box');


        var error = 0;
        if(fio.length > 0) {
            if (fio.val() === '') {
                fio.closest('.form_input_box').find('.form-error').text(fio.closest('.form_input_box').find('.form-error').data('error'));
                fio.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                var valuesCount = fio.val().trim().split(' ').filter(function (v) { return v !== '' });

                if (valuesCount.length > 1) {
                    fio.closest('.form_input_box').removeClass('error');
                } else {
                    fio.closest('.form_input_box').find('.form-error').text(fio.closest('.form_input_box').find('.form-error').data('alternate'));
                    fio.closest('.form_input_box').addClass('error');
                    ++error;
                }
            }
        }
        
        if(first_name.length > 0) {
            if (first_name.val() === '') {
                first_name.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                first_name.closest('.form_input_box').removeClass('error');
            }
        }

        if(sur_name.length > 0) {
            if (sur_name.val() === '') {
                sur_name.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                sur_name.closest('.form_input_box').removeClass('error');
            }
        }

        if(middle_name.length > 0) {
            if (middle_name.val() === '' && middle_name.closest('.js-box-required').length) {
                middle_name.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                middle_name.closest('.form_input_box').removeClass('error');
            }
        }

        if(sex.length > 0) {
            if (sex.val() === '') {
                sex.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                sex.closest('.form_input_box').removeClass('error');
            }
        }

        if(age.length > 0) {
            if (age.val() === '' && age.closest('.js-box-required').length) {
                age.closest('.form_input_box').addClass('error');
                ++error;
            } else {
	            if (age.val().toString().trim().length > 1 && !$.isNumeric(age.val())) {
                    age.closest('.form_input_box').find('.form-error').text(age.closest('.form_input_box').find('.form-error').data('alternate'));
                    age.closest('.form_input_box').addClass('error');
                    ++error;
                } else {
                    age.closest('.form_input_box').removeClass('error');
                }
            }
        }
        
        if(phone.length > 0) {
            if ((phone.val() && !validatePhone(phone.val())) || (phone.closest('.js-box-required').length && phone.val() === '')) {
                phone.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                phone.closest('.form_input_box').removeClass('error');
            }
        }
        
        if(email.length > 0) {
            if (email.val() && !validateEmail(email.val()) || (email.closest('.js-box-required').length && email.val() === '')) {
            	email.closest('.form_input_box').addClass('error');
                ++error;
            } else {
            	email.closest('.form_input_box').removeClass('error');
            }
        }
        
        if(company.length > 0) {
            if (company.closest('.js-box-required').length && company.val() === '') {
                company.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                company.closest('.form_input_box').removeClass('error');
            }
        }

        if(position.length > 0) {
            if (position.closest('.js-box-required').length && position.val() === '') {
                position.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                position.closest('.form_input_box').removeClass('error');
            }
        }

        if(stag.length > 0) {
            if (stag.closest('.js-box-required').length && stag.val() === '') {
                stag.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                stag.closest('.form_input_box').removeClass('error');
            }
        }

        if(address.length > 0) {
            if (adressBox.hasClass('js-box-required') && city.val() === '') {
                adressBox.find('.form-error').text(adressBox.find('.form-error').data('error'));
                adressBox.addClass('error');
                ++error;
                cityError = true;
            } else {
                if(address.val() && !city.val()){
                    adressBox.find('.form-error').text(adressBox.find('.form-error').data('alternate'));
                    adressBox.addClass('error');
                    ++error;
                    cityError = true;
                }else {
                    adressBox.removeClass('error');
                }
            }
        }else{
            if (country.closest('.js-box-required').length && country.val() === '') {
                country.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                country.closest('.form_input_box').removeClass('error');
            }

            if (city.closest('.js-box-required').length && city.val() === '') {
                city.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                city.closest('.form_input_box').removeClass('error');
            }
        }


        if(agree.length > 0) {
            if (!agree.is(':checked')) {
                agree.closest('.test_end_box').addClass('error');
                ++error;
            } else {
                agree.closest('.test_end_box').removeClass('error');
            }
        }

        if (error) {
            e.preventDefault();
        }
    });
    
    // Проверка формы профиля должности
    $('.js-quest-form-pd').submit(function (e) {
	    
        var position = $(this).find('input[name="position"]'),
        	company = $(this).find('input[name="company"]'),
        	fios = $(this).find('input[name="fios[]"]'),
            positions = $(this).find('input[name="positions[]"]'),
            stags = $(this).find('input[name="stags[]"]'),
            email = $(this).find('input[name="email"]'),
            phone = $(this).find('input[name="phone"]'),
            agree = $(this).find('input[name="agree"]');

        var error = 0;
        
        if(position.length > 0) {
            if (position.closest('.js-box-required').length && position.val() === '') {
                position.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                position.closest('.form_input_box').removeClass('error');
            }
        }

		if(company.length > 0) {
            if (company.closest('.js-box-required').length && company.val() === '') {
                company.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                company.closest('.form_input_box').removeClass('error');
            }
        }
		
        if(fios.length > 0) {
	        fios.each(function(i){
			    if (i === 0){
				    if ($(this).closest('.js-box-required').length && $(this).val() === '') {
		                $(this).closest('.form_input_box').find('.form-error').text($(this).closest('.form_input_box').find('.form-error').data('error'));
		                $(this).closest('.form_input_box').addClass('error');
		                ++error;
		            } else if($(this).val()){
		                var valuesCount = $(this).val().trim().split(' ').filter(function (v) { return v !== '' });
		
		                if (valuesCount.length > 1) {
		                    $(this).closest('.form_input_box').removeClass('error');
		                } else {
		                    $(this).closest('.form_input_box').find('.form-error').text($(this).closest('.form_input_box').find('.form-error').data('alternate'));
		                    $(this).closest('.form_input_box').addClass('error');
		                    ++error;
		                }
		            } else{
                        $(this).closest('.form_input_box').removeClass('error');
                    }
		        }else if($(this).val() !== '') {
			    	var valuesCount = $(this).val().trim().split(' ').filter(function (v) { return v !== '' });
		
	                if (valuesCount.length > 1) {
	                    $(this).closest('.form_input_box').removeClass('error');
	                } else {
	                    $(this).closest('.form_input_box').find('.form-error').text($(this).closest('.form_input_box').find('.form-error').data('alternate'));
	                    $(this).closest('.form_input_box').addClass('error');
	                    ++error;
	                }
			    }
	        });
        }
        
        if(positions.length > 0) {
	    	positions.each(function(i){
		    	if (i === 0){
			    	if ($(this).closest('.js-box-required').length && $(this).val() === '') {
		                $(this).closest('.form_input_box').addClass('error');
		                ++error;
		            } else {
		                $(this).closest('.form_input_box').removeClass('error');
		            }
				}else if($(this).val() !== '') {
					if ($(this).val().toString().trim().length === 1) {
		                $(this).closest('.form_input_box').addClass('error');
		                ++error;
		            } else {
		                $(this).closest('.form_input_box').removeClass('error');
		            }
				}
		    });
	    }
	    
	    if(stags.length > 0) {
	    	stags.each(function(i){
		    	if (i === 0){
			    	if ($(this).closest('.js-box-required').length && $(this).val() === '') {
		                $(this).closest('.form_input_box').addClass('error');
		                ++error;
		            } else {
		                $(this).closest('.form_input_box').removeClass('error');
		            }
				}
		    });
	    }
        
        if(phone.length > 0) {
            if ((phone.val() && !validatePhone(phone.val())) || phone.closest('.js-box-required').length && phone.val() === '') {
                phone.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                phone.closest('.form_input_box').removeClass('error');
            }
        }
        
        if(email.length > 0) {
            if ((email.val() && !validateEmail(email.val())) || email.closest('.js-box-required').length && email.val() === '') {
            	email.closest('.form_input_box').addClass('error');
                ++error;
            } else {
            	email.closest('.form_input_box').removeClass('error');
            }
        }

        if(agree.length > 0) {
            if (!agree.is(':checked')) {
                agree.closest('.test_end_box').addClass('error');
                ++error;
            } else {
                agree.closest('.test_end_box').removeClass('error');
            }
        }

        if (error) {
            e.preventDefault();
        }
    });

    // Проверка формы профиля должности
    $('.js-quest-form-client').submit(function (e) {

        const client_fio = $(this).find('input[name="client_fio"]'),
            client_organization = $(this).find('input[name="client_organization"]'),
            client_position = $(this).find('input[name="client_position"]'),
            client_sex = $(this).find('input[name="client_sex"]'),
            lpr = $(this).find('input[name="lpr"]'),
            client_email = $(this).find('input[name="client_email"]'),
            client_phone = $(this).find('input[name="client_phone"]'),
            respondent_fio = $(this).find('input[name="respondent_fio"]'),
            respondent_organization = $(this).find('input[name="respondent_organization"]'),
            respondent_position = $(this).find('input[name="respondent_position"]'),
            respondent_email = $(this).find('input[name="respondent_email"]'),
            respondent_phone = $(this).find('input[name="respondent_phone"]'),
            agree = $(this).find('input[name="agree"]');

        let error = 0;

        if(client_fio.length > 0) {
            if (client_fio.closest('.js-box-required').length && client_fio.val() === '') {
                client_fio.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                client_fio.closest('.form_input_box').removeClass('error');
            }
        }

		if(client_organization.length > 0) {
            if (client_organization.closest('.js-box-required').length && client_organization.val() === '') {
                client_organization.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                client_organization.closest('.form_input_box').removeClass('error');
            }
        }

		if(client_position.length > 0) {
            if (client_position.closest('.js-box-required').length && client_position.val() === '') {
                client_position.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                client_position.closest('.form_input_box').removeClass('error');
            }
        }

        if(client_sex.length > 0) {
            if (client_sex.val() === '') {
                client_sex.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                client_sex.closest('.form_input_box').removeClass('error');
            }
        }

        if(lpr.length > 0) {
            if (lpr.val() === '') {
                lpr.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                lpr.closest('.form_input_box').removeClass('error');
            }
        }

		if(client_email.length > 0) {
            if ((client_email.val() && !validateEmail(client_email.val())) || (client_email.closest('.js-box-required').length && client_email.val() === '')) {
                client_email.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                client_email.closest('.form_input_box').removeClass('error');
            }
        }

		if(client_phone.length > 0) {
            if ((client_phone.val() && !validatePhone(client_phone.val())) || (client_phone.closest('.js-box-required').length && client_phone.val() === '')) {
                client_phone.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                client_phone.closest('.form_input_box').removeClass('error');
            }
        }

        if(respondent_fio.length > 0) {
            if (respondent_fio.closest('.js-box-required').length && respondent_fio.val() === '') {
                respondent_fio.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                respondent_fio.closest('.form_input_box').removeClass('error');
            }
        }

        if(respondent_organization.length > 0) {
            if (respondent_organization.closest('.js-box-required').length && respondent_organization.val() === '') {
                respondent_organization.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                respondent_organization.closest('.form_input_box').removeClass('error');
            }
        }

        if(respondent_position.length > 0) {
            if (respondent_position.closest('.js-box-required').length && respondent_position.val() === '') {
                respondent_position.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                respondent_position.closest('.form_input_box').removeClass('error');
            }
        }

		if(respondent_email.length > 0) {
            if ((respondent_email.val() && !validateEmail(respondent_email.val())) || (respondent_email.closest('.js-box-required').length && respondent_email.val() === '')) {
                respondent_email.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                respondent_email.closest('.form_input_box').removeClass('error');
            }
        }

		if(respondent_phone.length > 0) {
            if ((respondent_phone.val() && !validatePhone(respondent_phone.val())) || (respondent_phone.closest('.js-box-required').length && respondent_phone.val() === '')) {
                respondent_phone.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                respondent_phone.closest('.form_input_box').removeClass('error');
            }
        }

        if(agree.length > 0) {
            if (!agree.is(':checked')) {
                agree.closest('.test_end_box').addClass('error');
                ++error;
            } else {
                agree.closest('.test_end_box').removeClass('error');
            }
        }

        if (error) {
            e.preventDefault();
        }
    });
    
    // Проверка формы физических лиц
    $('.js-quest-form-individual').submit(function (e) {
	    
        var name = $(this).find('input[name="name"]'),
        	surname = $(this).find('input[name="surname"]'),
        	gender = $(this).find('input[name="gender"]'),
        	age = $(this).find('input[name="age"]'),
            phone = $(this).find('input[name="phone"]'),
            email = $(this).find('input[name="email"]'),
            country = $(this).find('input[name="country"]'),
            city = $(this).find('input[name="city"]'),
            report = $(this).find('input[name="report[]"]');

        var adressBox = $(this).find('input[name="address"]').closest('.form_input_box');


        var error = 0;
        if(name.length > 0) {
            if (name.val() === '') {
                name.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                name.closest('.form_input_box').removeClass('error');
            }
        }
        
        if(surname.length > 0) {
            if (surname.val() === '') {
                surname.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                surname.closest('.form_input_box').removeClass('error');
            }
        }
                
        if(gender.length > 0) {
            if (gender.val() === '') {
                gender.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                gender.closest('.form_input_box').removeClass('error');
            }
        }

        if(age.length > 0) {
            if (age.val() === '') {
                age.closest('.form_input_box').addClass('error');
                ++error;
            } else {
	            if (age.val().toString().trim().length > 1 && $.isNumeric(age.val())) {
                    age.closest('.form_input_box').removeClass('error');
                } else {
                    age.closest('.form_input_box').find('.form-error').text(age.closest('.form_input_box').find('.form-error').data('alternate'));
                    age.closest('.form_input_box').addClass('error');
                    ++error;
                }
            }
        }
        
        if(phone.length > 0) {
            if (!validatePhone(phone.val()) || phone.val() === '') {
                phone.closest('.form_input_box').addClass('error');
                ++error;
            } else {
                phone.closest('.form_input_box').removeClass('error');
            }
        }
        
        if(email.length > 0) {
            if (!validateEmail(email.val())) {
            	email.closest('.form_input_box').addClass('error');
                ++error;
            } else {
            	email.closest('.form_input_box').removeClass('error');
            }
        }   
/*
		// Делаем обязательным только поле города, страну Google пришлет сам, если она у него будет указана
        if(country.length > 0) {
            if (country.val() === '') {
                adressBox.find('.form-error').text(adressBox.find('.form-error').data('error'));
                adressBox.addClass('error');
                ++error;
                countryError = true;
            } else {
                if (country.val().toString().trim().length > 1) {
                    adressBox.removeClass('error');
                } else {
                    adressBox.find('.form-error').text(adressBox.find('.form-error').data('alternate'));
                    adressBox.addClass('error');
                    ++error;
                    countryError = true;
                }
            }
        }
*/
        if(city.length > 0 && !countryError) {
            if (city.val() === '') {
                adressBox.find('.form-error').text(adressBox.find('.form-error').data('error'));
                adressBox.addClass('error');
                ++error;
                cityError = true;
            } else {
                if (city.val().toString().trim().length > 1) {
                    adressBox.removeClass('error');
                } else {
                    adressBox.find('.form-error').text(adressBox.find('.form-error').data('alternate'));
                    adressBox.addClass('error');
                    ++error;
                    cityError = true;
                }
            }
        }
        
        if (report.filter(':checked').length == 0) {
        	report.eq(0).closest('.js-checkbox-list').addClass('error');
            ++error;
        } else {
        	report.eq(0).closest('.js-checkbox-list').removeClass('error');
        }

        if (error) {
            e.preventDefault();
        }
    });

});
$(document).ready(function() {
    // if ($('.popup-success').hasClass('popup_manual')) {
    //     $('.cover').addClass('cover_visible');
    //     $('.popup').addClass('popup_opened');
    // }

    $('.js-popup-link').on('click', function (e) {
        e.preventDefault();
        
        var id = $(this).attr('href');
        
        if ($(id).length > 0) {
            $('.cover').addClass('cover_visible');
            $(id).addClass('popup_opened');

            if ($(window).width() > 700) {
                if (!$(id).hasClass('popup_long')) {
                    $('body').addClass('overflow_hid');
                } else {
                    $('body, html').animate({scrollTop: 0}, 300);
                }
            } else {
                if ($(id).hasClass('popup_long')) {
                    $('body, html').animate({scrollTop: 0}, 300);
                }
                $('body').addClass('overflow_hid');
            }
            
        }
    });

    $('.js-mfp-link').magnificPopup({
        type: 'inline',

        fixedContentPos: true,
        fixedBgPos: true,

        overflowY: 'auto',

        closeBtnInside: false,
        preloader: false,
        modal: false,

        midClick: true,
        removalDelay: 200,
        mainClass: 'mfp-move-horizontal',
        callbacks: {
            open: function () {
                // $('body').addClass('overflow_hid');
            },
            close: function () {
                // $('body').removeClass('overflow_hid');
            }
        }
    });
    

    $('.close_pop').on('click', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });
});

function func() {
    $('.popup').each(function () {
        if (!$(this).hasClass('popup_manual')) {
            $('.cover').addClass('cover_visible');
            $(this).addClass('popup_opened');
        }
        
        if ($(this).hasClass('popup_success') && $(this).hasClass('popup_opened')) {
            setTimeout(function () {
                $('.cover').removeClass('cover_visible');
                $('.popup_opened').removeClass('popup_opened');
                $('body').removeClass('overflow_hid');
            },4000);
        }
    });
    
    if ($('.popup').not('.popup_manual').length > 0) {
        $('body').addClass('overflow_hid');
    }
}

setTimeout(func, 2000);

$('.close_pop, .js-close-popup').click(function() {
    $('.cover').removeClass('cover_visible');
    $('.popup').removeClass('popup_opened');
    $('body').removeClass('overflow_hid');
});

$('#help_test').on('click', function() {
    $('.cover').addClass('cover_visible');
    $('.test-rules').addClass('popup_opened');
    $('body').addClass('overflow_hid');
});

$('*[href="#close-modal"]').on('click', function() {
    $('body').removeClass('overflow_hid');
});

jQuery(document).click(function (e) {
    var isPopup = $(e.target).closest('.popup').hasClass('popup_opened') || $(e.target).hasClass('popup_opened');
    
    var isBtn = $(e.target).closest('a').hasClass('js-popup-link') || $(e.target).hasClass('js-popup-link');

    var isOpen = $('.popup').hasClass('popup_opened');
    
    
    if (!isPopup && isOpen && !isBtn) {
        $('.cover').removeClass('cover_visible');
        $('.popup').removeClass('popup_opened');
        $('body').removeClass('overflow_hid');
    }
});
$(function () {

    //Draggable
    $('.drag--draggable').draggable();
    
    var sortTable = false;
    var initSortTable = false;

    var allChangeBlocks = function () {
        if ($('.drag_box').children('.dragged').length > 3) {
            $('.test_footer').children('.right').find('.btn--next').removeClass('btn_inactive');

            var max = $('.drag_box').children('.ag_box:nth-of-type(1)').children('.drag_item').data('id');
            var more = $('.drag_box').children('.ag_box:nth-of-type(2)').children('.drag_item').data('id');
            var less = $('.drag_box').children('.ag_box:nth-of-type(3)').children('.drag_item').data('id');
            var min = $('.drag_box').children('.ag_box:nth-of-type(4)').children('.drag_item').data('id');
            
            if (max && min && more && less) {
                $('#nexttest').children('input[name="max"]').val(max);
                $('#nexttest').children('input[name="min"]').val(min);
	            $('#nexttest').children('input[name="more"]').val(more);
                $('#nexttest').children('input[name="less"]').val(less);
            }
        }
    };

    $('.drag--draggable').draggable({
        containment: $(".drag"),
        start: function () {
            $('.drag--draggable').addClass('active_drag');
            $('.drop--draggable').addClass('active_drop');
        },
        stop: function () {
            $('.draggable--draggable').removeClass('active_drag');
            $('.drop--draggable').removeClass('active_drop');
        },
        revert: 'invalid',
        activeClass: "active_grab"
    });
    
    var drop_item = function(e, ui){
	    var el = ui.draggable;
        if ($(el).closest('.left').length && !$(this).closest('.ag_box').hasClass('dragged')) {
            
            var blockid = $(el).closest('.drag_item').data('id');

            $(this).closest('.ag_box').addClass('dragged');
            $('.draggable--draggable').addClass('dropped');
            $(this).addClass('dragged');
            $(this).find('.drag_item--toElement').text($(el).text()).closest('.drag_item').data('id', blockid);
            $(el).closest('.drag_item').remove();

            sortTable = true;

            $(this).droppable("disable");
        }

        allChangeBlocks();

        if (sortTable && !initSortTable) {
            $('.drag_box').sortable({
                cursor: "move",
                revert: true,
                start: function () {
                    $('.test_footer').children('.right').find('.btn--next').addClass('btn_inactive');
                },
                stop: allChangeBlocks
            });
            initSortTable = true;
        }
    };

    $('.droppable--draggable').droppable({
        drop: drop_item,
        activeClass: "active_drop",
        hoverClass: "hover_drop",
        accept: ".drag_item"
    });
	
	$('.drag .left .drag_item[data-save]').each(function(){
    	var position = $(this).data('save');
    	var box = $('.drag_box').children('.ag_box:nth-of-type('+position+')').children('.drag_item');
    	var ui = new Object()
    	ui.draggable = $(this);
    	drop_item.call(box, window.event, ui);
 
	});
});
$('.call_sh').on('click', function() {
    $('.show_call').addClass('show_b');
    $('.call_sh').css('display', 'none');
});

$('.close_btns').on('click', function() {
    $('.show_call').removeClass('show_b');
    $('.call_sh').fadeIn(500);
});
var timer_sec = 0;
function timer_start(){
	var timer_box = $('.timer_box');
	if(timer_box.length == 1){
	    setInterval(function() {
	        $("#seconds").html(pad(++timer_sec % 60));
	        $("#minutes").html(pad(parseInt(timer_sec / 60, 10)));
			$('#timer').val(timer_sec);
	        if (+$("#minutes").text() > 20) {
	            timer_box.addClass('time_less');
	            $('.timer').addClass('no_time');
	        }
	        else {
	            timer_box.removeClass('time_less');
	            $('.timer').removeClass('no_time');
	        }
	    }, 1000);
	}
}
function timer_run(){
	timer_sec = 0;
	timer_start();
}
function pad(val) { return val > 9 ? val : "0" + val; }
$(document).ready(function () {
	var timer_box = $('.timer_box');
	if(timer_box.length == 1){
	    timer_box.addClass('hide');
	    
	    var timer_data = $('[data-timer]').data('timer');
	    timer_sec = timer_data ? timer_data : 0;
	
	    setTimeout(function () {
	        timer_box.removeClass('hide');
	    },1000);
	    
	    // Запускаем таймер сразу на всех блоках, кроме первой
	    if($(window).width() <= 1200|| !$('.question_count li').eq(0).hasClass('active_q') || $('.cd-tour-wrapper.cd-tour-manual').exists()){
		    timer_start();
	    }
	}
});
var inputValidate = window.inputValidate();

$(document).ready(function() {
    $('form').on('focus', '.test_input, .text_input', function(){
        $(this).parents('.form_input_box').addClass('focused').removeClass('lost-focus');
    });

    $('form').on('blur', '.test_input, .text_input', function(){
        var inputValue = $(this).val();
        var input = $(this);
        
        if ( inputValue === "" ) {
            $(this).removeClass('filled');

        } else {
            $(this).addClass('filled');
        }
        
        $(this).parents('.form_input_box').removeClass('focused').addClass('lost-focus');
        
        setTimeout(function () {
            inputValidate(input);
        },100);
    });
});
jQuery(document).ready(function($){
    //check if a .cd-tour-wrapper exists in the DOM - if yes, initialize it
    
    if ($('.cd-tour-wrapper').exists()) {
        initTour();
        if($('.cd-tour-wrapper:not(.cd-tour-manual)').exists()){
        	setTimeout(openTour, 2000);
		}
    }

    function openTour() {
        var tourWrapper = $('.cd-tour-wrapper'),
            tourSteps = tourWrapper.children('li'),
            coverLayer = $('.cd-cover-layer');
        
        if(!tourWrapper.hasClass('active') && $('.question_count li').eq(0).hasClass('active_q')) {
            //in that case, the tour has not been started yet
            if ($(window).width() > 1200) {
                tourWrapper.addClass('active');
                showStep(tourSteps.eq(0), coverLayer);
                $(window).on('resize orientationchange', offTour);
            } else {
                $('.help[rel="modal:open"]').trigger('click');
            }
        }
    }
    
    function initTour() {
        var tourWrapper = $('.cd-tour-wrapper'),
        tourSteps = tourWrapper.children('li'),
        stepsNumber = tourSteps.length,
        coverLayer = $('.cd-cover-layer'),
        tourStepInfo = $('.cd-more-info'),
        tourTrigger = $('#cd-tour-trigger');

        //create the navigation for each step of the tour
        createNavigation(tourSteps, stepsNumber);

        tourTrigger.on('click', function(){
            //start tour
            if(!tourWrapper.hasClass('active')) {
                //in that case, the tour has not been started yet
                tourWrapper.addClass('active');
                showStep(tourSteps.eq(0), coverLayer);
            }
        });

        //change visible step
        tourStepInfo.on('click', '.cd-prev', function(event){
            //go to prev step - if available
            ( !$(event.target).hasClass('inactive') ) && changeStep(tourSteps, coverLayer, 'prev');
        });
        tourStepInfo.on('click', '.cd-next', function(event){
            //go to next step - if available
            if (!$(event.target).hasClass('inactive')) {
                changeStep(tourSteps, coverLayer, 'next');
            } else {
                closeTour(tourSteps, tourWrapper, coverLayer);
            }
        });

        //close tour
        tourStepInfo.on('click', '.cd-close', function(event){
            closeTour(tourSteps, tourWrapper, coverLayer);
        });

        //detect swipe event on mobile - change visible step
        tourStepInfo.on('swiperight', function(event){
            //go to prev step - if available
            if( !$(this).find('.cd-prev').hasClass('inactive') && viewportSize() == 'mobile' ) changeStep(tourSteps, coverLayer, 'prev');
        });
        tourStepInfo.on('swipeleft', function(event){
            //go to next step - if available
            if( !$(this).find('.cd-next').hasClass('inactive') && viewportSize() == 'mobile' ) changeStep(tourSteps, coverLayer, 'next');
        });

        //keyboard navigation
        $(document).keyup(function(event){
            if( event.which=='37' && !tourSteps.filter('.is-selected').find('.cd-prev').hasClass('inactive') ) {
                changeStep(tourSteps, coverLayer, 'prev');
            } else if( event.which=='39' && !tourSteps.filter('.is-selected').find('.cd-next').hasClass('inactive') ) {
                changeStep(tourSteps, coverLayer, 'next');
            } else if( event.which=='27' ) {
                closeTour(tourSteps, tourWrapper, coverLayer);
            }
        });
    }
    
    function offTour(){
	    var tourWrapper = $('.cd-tour-wrapper'),
            tourSteps = tourWrapper.children('li'),
            coverLayer = $('.cd-cover-layer');
            
	    if($(window).width() <= 1200) {
			closeTour(tourSteps, tourWrapper, coverLayer);
		}
    }

    function createNavigation(steps, n) {
        var tourNavigationHtml = '<div class="cd-nav"><span><b class="cd-actual-step">1</b>/'+n+'</span><ul class="cd-tour-nav"><li><a href="javascript:;" class="cd-prev">'+tour_lang['back']+'</a></li><li><a href="javascript:;" class="cd-next">'+tour_lang['next']+'</a></li></ul></div><a href="javascript:;" class="cd-close">'+tour_lang['skip']+'</a>';

        steps.each(function(index){
            var step = $(this),
            stepNumber = index + 1,
            nextClass = ( stepNumber < n ) ? '' : 'inactive',
            prevClass = ( stepNumber == 1 ) ? 'inactive' : '';
            var nav = $(tourNavigationHtml).find('.cd-next').addClass(nextClass).end().find('.cd-prev').addClass(prevClass).end().find('.cd-actual-step').html(stepNumber).end().appendTo(step.children('.cd-more-info'));
        });
    }

    function showStep(step, layer) {

        if (step.index() > 7 || (($('.pd_hint').exists() || $('.client_hint').exists()) && step.index() > 6) ) {
            $(step).closest('.cd-single-step').find('.cd-close').addClass('cd-end');
            $(step).closest('.cd-single-step').find('.cd-close').remove();
            $(step).closest('.cd-single-step').find('.cd-tour-nav li:last-of-type a')
                .text(tour_lang['enter']);
        } else {
            $(step).closest('.cd-single-step').find('.cd-close').removeClass('cd-end');
            $(step).closest('.cd-single-step').find('.cd-tour-nav li:last-of-type a')
                .text(tour_lang['next']);
        }

        step.addClass('is-selected').removeClass('move-left');
        smoothScroll(step.children('.cd-more-info'));
        showLayer(layer);
        
        var realIndex = +step.index() + 1;
        $('.test-hint__parent').removeClass('active');
        $('.test-hint__parent[data-hint*="' + realIndex + '"]').addClass('active');
        $('.page-container').attr( 'class', $('.page-container').attr('class').replace(/\bhint_\d+\b/g, '') );
        $('.page-container').addClass('hint_' + realIndex);
        
    }

    function smoothScroll(element) {
        (element.offset().top < $(window).scrollTop()) && $('body,html').animate({'scrollTop': element.offset().top}, 100);
        (element.offset().top + element.outerHeight() > $(window).scrollTop() + $(window).height() ) && $('body,html').animate({'scrollTop': element.offset().top + element.outerHeight() - $(window).height()}, 100);
    }

    function showLayer(layer) {
        layer.addClass('is-visible').on('webkitAnimationEnd oanimationend msAnimationEnd animationend', function(){
            layer.removeClass('is-visible');
        });
    }

    function changeStep(steps, layer, bool) {
        var visibleStep = steps.filter('.is-selected'),
        delay = (viewportSize() == 'desktop') ? 300: 0;
        visibleStep.removeClass('is-selected');

        (bool == 'next') && visibleStep.addClass('move-left');

        setTimeout(function(){
            ( bool == 'next' )
            ? showStep(visibleStep.next(), layer)
            : showStep(visibleStep.prev(), layer);
        }, delay);
    }

    function closeTour(steps, wrapper, layer) {
        if(wrapper.hasClass('active')){
	        steps.removeClass('is-selected move-left');
	        wrapper.removeClass('active');
	        layer.removeClass('is-visible');
	        $('.test-hint__parent').removeClass('active');
	        $('.page-container').attr( 'class', $('.page-container').attr('class').replace(/\bhint_\d+\b/g, '') );
	        // Запускаем таймер только на первой странице
	        if($('.question_count li').eq(0).hasClass('active_q')){
	        	timer_run()
	        }
	    }
	    $(window).off('resize orientationchange', offTour);
    }

    function viewportSize() {
        /* retrieve the content value of .cd-main::before to check the actua mq */
        return window.getComputedStyle(document.querySelector('.cd-tour-wrapper'), '::before').getPropertyValue('content').replace(/"/g, "").replace(/'/g, "");
    }
});

//check if an element exists in the DOM
jQuery.fn.exists = function(){ return this.length > 0; }

$(function () {

    $('#nexttest').submit(function () {
        if ($(this).find('.btn--next.btn_inactive').length) {
            console.log('form has button class btn_inactive');
            return false;
        }else{
			$(this).find('.btn--next').addClass('btn_inactive');
		}
    });

	var box = $('.test_box .test_body__box');
	var box_big =  $('.test_box .test_questions');
	var footer =  $('.test_box .test_footer_test');

    if(box.length>0 && $('.page_test_layout').length>0){
		// Пробуем сначало уместить большой блок
		if(box_big.outerHeight() + footer.outerHeight() <= $(window).height()){
			box = box_big;
		}		
        if(box.offset().top + box.outerHeight() + footer.outerHeight() > $(window).scrollTop() + $(window).height() || box.offset().top < $(window).scrollTop() ){
	        if(box.outerHeight() + footer.outerHeight() >= $(window).height()){
		        $('body,html').animate({'scrollTop': box.offset().top}, 100);
		    }else{
			    $('body,html').animate({'scrollTop': footer.offset().top  + footer.outerHeight() - $(window).height()}, 100);
		    }
		}
    }
    
});
var keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault)
        e.preventDefault();
    e.returnValue = false;
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
}

function disableScroll() {
    if (window.addEventListener) // older FF
        window.addEventListener('DOMMouseScroll', preventDefault, false);
    window.onwheel = preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
    window.ontouchmove = preventDefault; // mobile
    document.onkeydown = preventDefaultForScrollKeys;
}

function enableScroll() {
    if (window.removeEventListener)
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
}
$(document).ready(function () {
	//Sticky
	var element1 = $('.sticky');
	var element2 = $('.right-sticky');
	var element3 = $('.sticky-360');
	Stickyfill.add(element1,element2,element3);
});
$('.test_lang__form ul li').on('click', function(){
	url = $('a',this).attr('href');
	if(url){
		window.location = url;
	}
});
$(document).ready(function() {
	$('.js-checkbox').on('change', function() {
		var thisTarget = $('#report-' + $(this).data('item') );
	
		if ( $(this).is(':checked') ) {
			thisTarget.text('1');
		}
		else {
			thisTarget.text('0');
		}
	});
	
	$('.js-filling-button').on('click', function() {
		$(this).closest('.js-popup-filling').hide();
		$('body').removeClass('overflow_hid');
	});
});
//removeIf(development)
$(document).ready(function () {
    $('[data-ym]').each(function (){
        if(typeof ym !== "undefined") {
            ym(48778664, 'reachGoal', $(this).data('ym'));
        }
    });
});
//endRemoveIf(development)